import { TabsReducer } from '../../../../common/tabs/tabs.reducer';
import {IDS} from "../settings-action-id.constants";

export const requirementsTabs = {
    [IDS.app_accreditation_scheme_settings_requirements]: Object.assign(TabsReducer(), {
        tabs: [
            {
                state: IDS.app_accreditation_scheme_settings_requirements_list,
                title: 'ACCREDITATION.SETTINGS.REQUIREMENTS.LIST.TAB',
                visible: true,
                disabled: false,
                loading: false,
            },
            {
                state: IDS.app_accreditation_scheme_settings_requirements_imports,
                title: 'ACCREDITATION.SETTINGS.REQUIREMENTS.IMPORTS.TAB',
                visible: false,
                disabled: false,
                loading: false,
            },
        ],
    }),
};
